export default __webpack_public_path__ + "static/media/soccer-icon.48848a9d.svg";